export default __webpack_public_path__ + "static/media/delete.22fd5cf6.svg";